module.exports = __webpack_public_path__ + "static/media/upp_flo_saf_lad.0955c12a.png";